@if (currentAccount) {
  <app-customer-resume-bar [customer]="currentAccount"></app-customer-resume-bar>
}
@if (currentTask.status !== TaskStatusEnum.OPEN && currentTask.status !== TaskStatusEnum.LOCKED) {
  <div class="task-closed-banner">
    <mat-icon>lock</mat-icon>
    This task is <strong>{{ currentTask.status }}</strong>. The information below is read-only.
  </div>
}

@if (isPropertyOnlyTask && (currentTask.status === TaskStatusEnum.OPEN || currentTask.status === TaskStatusEnum.LOCKED)) {
  @for (m of unresolvedMatches; track m.propertyId) {
    <app-property-match-card [match]="m" [newIsManagementCompany]="newIsManagementCompany" [busy]="matchBusy"
                             (link)="onLink(m, $event.newIsHome)" (notSame)="onNotSame(m)"></app-property-match-card>
  }
}
@if (linkResult) {
  <div class="link-result">
    <mat-icon>link</mat-icon>
    <div>
      Linked with {{ linkedAccountName }}. Handoff date: {{ linkResult.handoffDate | date }}.
      @if (linkResult.duplicatePeriods.length) {
        <div class="link-duplicates">These periods were already billed on both accounts — amend/credit them: {{ linkResult.duplicatePeriods.join(', ') }}</div>
      }
      <div class="link-hint">Declining this property requires unlinking it first.</div>
    </div>
    <button mat-button type="button" color="warn" [disabled]="matchBusy" (click)="unlinkResult()">Unlink</button>
  </div>
}

@if (isPropertyOnlyTask && currentProperty) {
  <div class="task-detail-container" [class.task-closed]="currentTask.status !== TaskStatusEnum.OPEN && currentTask.status !== TaskStatusEnum.LOCKED">
    <h2 class="property-review__title">
      <mat-icon>home</mat-icon> New property for review
    </h2>
    <app-enrollment-rental-property
      [property]="currentProperty"
      [owners]="propertyOwners">
    </app-enrollment-rental-property>
  </div>
}

@if (currentEnrollment) {
  <div class="task-detail-container" [class.task-closed]="currentTask.status !== TaskStatusEnum.OPEN && currentTask.status !== TaskStatusEnum.LOCKED">
    @switch (currentEnrollment.enrollmentType) {
      @case (EnrollmentType.INDIVIDUAL_OWNER) {
        <app-individual-owner-enrollment [enrollment]="currentEnrollment"></app-individual-owner-enrollment>
      }
      @case (EnrollmentType.PROPERTY_MANAGEMENT) {
        <app-property-management-enrollment [enrollment]="currentEnrollment"></app-property-management-enrollment>
      }
      @case (EnrollmentType.INDIVIDUAL_BED) {
        <app-individual-bed-enrollment [enrollment]="currentEnrollment"></app-individual-bed-enrollment>
      }
      @default {
        <app-under-construction></app-under-construction>
      }
    }
  </div>
}

<app-task-action-bar
  [disabled]="disableSubmit"
  [currentTask]="currentTask"
  [saving]="saving"
  (isTaskApproved)="isTaskApproved($event)"
  (save)="saveEdits()">
</app-task-action-bar>
